<div class="modal-container">
  <!-- Header -->
  <div class="modal-header">
    <h2>{{ 'SELECT_PRODUCTS' | translate}}</h2>
    <button class="btn-close" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div>
    <!-- Search & Filters -->
    <div class="modal-filters">
      <div class="search-wrapper">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          [formControl]="searchControl"
          type="text"
          class="search-input"
          placeholder="{{ 'SEARCH_PRODUCTS' | translate}}"
        >
      </div>
      <!-- <select class="filter-select" [(ngModel)]="filterBy">
        <option value="All">Search by All</option>
        <option value="Title">Title</option>
        <option value="SKU">SKU</option>
      </select>
      <button class="btn-add-filter">
        Add filter +
      </button> -->
    </div>

    <!-- Product Table Header -->
    <div class="table-header" *ngIf="!isLoading">
      <span class="col-product">{{ 'PRODUCT' | translate}}</span>
      <span class="col-available">{{ 'AVAILABLE' | translate}}</span>
      <span class="col-price">{{ 'PRICE' | translate}}</span>
    </div>

    <!-- Loading State -->
    <div class="loading-state" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading products...</p>
    </div>

    <!-- Product List -->
    <div class="product-list" *ngIf="!isLoading">
      <div *ngIf="products?.length === 0" class="no-results">
        <mat-icon>search_off</mat-icon>
        <p>{{ 'NO_PRODUCTS_FOUND' | translate}}</p>
      </div>

      <div class="product-group" *ngFor="let product of products">
        <!-- Group Header -->
        <div class="group-header">
          <!-- <button class="btn-toggle" (click)="toggleGroup(product)">
            <mat-icon>{{ product.expanded ? 'remove' : 'add' }}</mat-icon>
          </button> -->
          <div class="group-image" *ngIf="product.imageURL">
            <img [src]="product.imageURL || 'assets/static/missing-image.png'" 
                 [alt]="product.productName">
          </div>
          <span class="group-name">{{ product.productName }}</span>
        </div>

        <div class="variant-row" *ngFor="let variant of product.items" [class.expanded]="product.expanded">
          <div class="variant-checkbox">
            <input
              type="checkbox"
              [checked]="isVariantSelected(variant.itemId)"
              (change)="toggleVariant(variant)"
            >
          </div>
          <span class="variant-size">{{ variant.variantValues? variant.variantValues[0] :product.productName }}</span>
          <span class="variant-available">
            {{ variant.quantity }}
          </span>
          <span class="variant-price">{{ formatPrice(variant.itemPrice) }}</span>
        </div>

        <!-- Variants -->
        <!-- <div class="variant-row" 
             *ngFor="let variant of product.variants" 
             [class.expanded]="product.expanded"
             [class.out-of-stock]="variant.available === 0">
          <div class="variant-checkbox">
            <input
              type="checkbox"
              [checked]="isVariantSelected(variant.id)"
              [disabled]="variant.available === 0"
              (change)="toggleVariant(variant)"
            >
          </div>
          <span class="variant-size">{{ variant.size }}</span>
          <span class="variant-available" [class.low-stock]="variant.available === 0">
            <mat-icon *ngIf="variant.available === 0" class="warning-icon">warning</mat-icon>
            {{ variant.available }}
          </span>
          <span class="variant-price">{{ formatPrice(variant.price) }}</span>
        </div> -->
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <span class="selection-count">
        {{ selectedCount }}/{{ maxVariants }}
      </span>
      <div class="footer-actions">
        <button class="btn btn-outline" (click)="onCancel()">{{ 'CANCEL' | translate}}</button>
        <button class="btn btn-primary" (click)="onAdd()" [disabled]="selectedCount === 0">
          {{ 'ADD' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>